import { Form, FormInstance } from "antd/es";

export interface IWithFormProp<T> {
  form: FormInstance<T>;
}

export const WithForm = <P extends object>(Component: any) => {
  return (props: P) => {
    const [form] = Form.useForm();
    return <Component form={form} {...props} />;
  };
};
